export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7035.42dad564.jpg";